import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium text-black pb-6" }, " Choose how long the contact should wait before moving to the next action ", -1)
const _hoisted_3 = { class: "flex gap-x-2.5 pb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "test-sm text-gray-400 font-light" }, "1 day is equal to a 24 hour period", -1)

import { watch } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import { useWorkflowStore } from "@/stores/workflow"


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeAmountComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

watch(
    () => [
        workflowStore.modelValue.time?.days,
        workflowStore.modelValue.time?.hours,
        workflowStore.modelValue.time?.minutes,
    ],
    () => {
        workflowStore.areButtonDisabled = !(
            workflowStore.modelValue.time?.days !== 0 ||
            workflowStore.modelValue.time?.hours !== 0 ||
            workflowStore.modelValue.time?.minutes !== 0
        )
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(GgmsInput, {
        modelValue: _unref(workflowStore).modelValue.time.days,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.time.days) = $event)),
        type: "number",
        label: "Days"
      }, null, 8, ["modelValue"]),
      _createVNode(GgmsInput, {
        modelValue: _unref(workflowStore).modelValue.time.hours,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).modelValue.time.hours) = $event)),
        type: "number",
        label: "Hours"
      }, null, 8, ["modelValue"]),
      _createVNode(GgmsInput, {
        modelValue: _unref(workflowStore).modelValue.time.minutes,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(workflowStore).modelValue.time.minutes) = $event)),
        type: "number",
        label: "Minutes"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_4
  ]))
}
}

})